import GOGovLogo from '@/go.gov/components/layout/GOGovLogo';
import { AppBar, Box, Grid, Link, Toolbar, Typography } from '@mui/material';
import Image from 'next/image';

export const FOOTER_HEIGHT = 300;

export function GoGovFooter() {
  return (
    <AppBar
      position='static'
      sx={{
        backgroundColor: 'black',
        height: FOOTER_HEIGHT,
        mt: 'auto',
      }}
      component='footer'
    >
      <Toolbar
        disableGutters
        sx={{
          backgroundColor: '#DFE1E2',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          color: 'black',
          py: 2,
          px: 6,
        }}
      >
        <GOGovLogo ignoreMargin />

        {/* Right: Text */}
        <Typography variant='body2' sx={{ color: 'black', textAlign: 'right' }}>
          Please consult your agency for relevant policies and regulations.
        </Typography>
      </Toolbar>

      <Toolbar
        disableGutters
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          py: 2,
          px: 6,
        }}
      >
        {/* Top Row: Logo + Text */}
        <Box display='flex' alignItems='center' mb={2}>
          <Image
            width={50}
            height={50}
            src='/assets/gsa.png'
            alt='GSA Logo'
            priority
          />

          <Box>
            <Typography variant='body1' sx={{ color: 'white' }}>
              GO.gov
            </Typography>
            <Typography
              variant='body2'
              sx={{ color: 'white', fontWeight: 'bold' }}
            >
              An official website of the{' '}
              <Link
                href='https://www.gsa.gov/'
                target='_blank'
                sx={{
                  color: 'white !important',
                  textDecoration: 'underline',
                }}
              >
                General Services Administration
              </Link>
            </Typography>
          </Box>
        </Box>

        {/* Middle Row: Links */}
        <Grid container spacing={3} sx={{ mb: 2 }}>
          {[
            { label: 'About GSA', href: 'https://www.gsa.gov/' },
            {
              label: 'FOIA Requests',
              href: 'https://www.gsa.gov/reference/freedom-of-information-act-foia/',
            },
            {
              label: 'Office of the Inspector General',
              href: 'https://www.gsaig.gov/',
            },
            {
              label: 'Privacy Policy',
              href: 'https://www.gsa.gov/website-information/website-policies/',
            },
            {
              label: 'Accessibility Support',
              href: 'https://www.gsa.gov/website-information/accessibility-statement/',
            },
            {
              label: 'No FEAR Act Data',
              href: 'https://www.gsa.gov/reference/civil-rights-programs/the-no-fear-act/',
            },
            {
              label: 'Performance Reports',
              href: 'https://www.gsa.gov/reference/reports/budget-and-performance/',
            },
          ].map((item) => (
            <Grid item xs={3} key={item.label}>
              <Link
                href={item.href}
                target='_blank'
                underline='always'
                sx={{ color: 'white !important', textDecoration: 'underline' }}
              >
                {item.label}
              </Link>
            </Grid>
          ))}
        </Grid>

        {/* Bottom Row: USA.gov Link */}
        <Typography variant='body2' sx={{ color: 'white' }}>
          Looking for U.S. government information and services?{' '}
          <Link
            href='https://www.usa.gov/'
            target='_blank'
            sx={{
              color: 'white !important',
              fontWeight: 'bold',
              textDecoration: 'underline',
            }}
          >
            Visit USA.gov
          </Link>
        </Typography>
      </Toolbar>
    </AppBar>
  );
}
